import React, { useEffect, useMemo } from 'react';
import { di } from 'react-magnetic-di';
import { useRequestTypeFields } from '../../../../services/request-type-fields-service';
import {
    SHORT_TEXT_FIELD_TYPE,
    PARAGRAPH_FIELD_TYPE,
    SINGLE_SELECT_FIELD_TYPE,
    DATE_PICKER_FIELD_TYPE,
    getFieldType,
} from '../../../../services/request-type-fields-service/utils';
import type { JiraFieldAppendix as JiraFieldAppendixType } from '../../../types';
import { DatePickerAppendix } from './date-picker';
import { SingleSelectFieldAppendix } from './single-select';

export const JiraFieldAppendix = ({ appendix }: { appendix: JiraFieldAppendixType }) => {
    di(useRequestTypeFields);

    const { fieldId, requestTypeId, projectId } = appendix;
    const [{ data, loading: isFieldsLoading }, { fetchRequestTypeFields }] = useRequestTypeFields();
    const field = useMemo(() => data.get(fieldId), [data, fieldId]);

    useEffect(() => {
        fetchRequestTypeFields(projectId, requestTypeId).catch(() => {
            /* ignore */
        });
    }, [fetchRequestTypeFields, projectId, requestTypeId]);

    if (isFieldsLoading || !field) {
        return <></>;
    }

    switch (getFieldType(fieldId, data)) {
        case DATE_PICKER_FIELD_TYPE:
            return <DatePickerAppendix field={field} />;
        case SINGLE_SELECT_FIELD_TYPE:
            return <SingleSelectFieldAppendix field={field} />;
        case PARAGRAPH_FIELD_TYPE:
        case SHORT_TEXT_FIELD_TYPE:
        default:
            return <></>;
    }
};
